import React, { Component } from "react";
import Layout from "../../layouts/Layout";

import NoData from "../../styles/Illustrations/NoData";
import { StyledCircularProgress } from "../../styles/StyledComponents";
import { EndPoints } from "../../utils/EndPoints";
import { Paper } from "@material-ui/core";
import Icon from "@mui/material/Icon";
import { ModeEdit } from "@mui/icons-material";
import Tooltip from "@material-ui/core/Tooltip";
import Popup from "./components/Popup";
import EditForm from "./components/EditForm";
import NewForm from "./components/NewForm";
import moment from "moment";
import { filterData, getSingleModule_widget } from "../../Regex";
import { accessText } from "../../routes/sidebar";

export class HsNsComponent extends Component {
  constructor(props) {
    const templateTabs = [
      {
        label: EndPoints["HsNs"],
        tooltip: `Click to approve pending ${EndPoints["HsNs"]}`,
        data: [],
        route: `/HsNs/${EndPoints["HsNs"].split("/")[0]}`,
        widget: null,
        goBackRoute: "/HsNs",
        primaryField: "hsn_code",
        primarySecondValue: "total_net_weight",
        primaryFieldFallback: "total_trips", // Optional
        secondaryField: "is_active",
        primaryFieldThirdFallback: "total_net_weight_pending_trips",
        avatarField: "src",

        decorators: {
          conditionField: "is_active",
          options: ["active", "inactive", "unidentified"],
          colors: ["#0AFF00", "#FF3D00", "grey"],
        },
      },
    ];
    super(props);
    this.setStateOfPopup.bind(this);
    this.state = {
      tabs: templateTabs,
      // listViewArray: [],
      HsNs: [],
      loading: false,
      singlelistView: null,
      loading: false,
      isNew: false,
    };
  }

  setStateOfPopup = (value) => {
    this.setState({ isPopup: value, isNew: false });
  };

  UNSAFE_componentWillReceiveProps(next) {
    this.setInitialValues(next);
  }
  UNSAFE_componentWillMount() {
    const next = this.props;
    if (next.params && next.params.tab) {
      let tab = next.params.tab;
      if (tab === EndPoints["HsNs"] && next.params.id) {
        this.setState(
          {
            singlelistView: this.state.tabs[0].data[next.params.id],
          },
          () => {
            if (this.state.singlelistView && this.state.singlelistView.id) {
              this.props.HsNsFunction(
                "get",
                this.props.user.uid,
                EndPoints["HsNs"],
                this.state.singlelistView.id,
                "HsNs"
              );
            }
          }
        );
      } else if (tab === "NEW") {
        this.setState({ singlelistView: null });
      }
    } else {
      this.setState({ singlelistView: null });
    }
    this.setInitialValues(this.props);
  }

  listClickHandler = (value) => {
    this.setState(
      {
        singlelistView: value,
      },

      () => {
        // if (this.state.singlelistView && this.state.singlelistView.id) {
        //   this.props.HsNsFunction(
        //     "get",
        //     "HsNs",
        //     this.state.singlelistView.id,
        //     "HsNs"
        //   );
        // }
      }
    );
  };
  searchHandler = (value) => {
    this.listClickHandler(value);
    // if (value && value.monthId) {
    //   if (this.state.selectedMonth.monthId !== value.monthId) {
    //     this.setState({ selectedMonth: value, singleDate: null, singleDateTrips: [], singleDateTripsCopy: [] });
    //     this.props.fetchHsNs(this.props.user.user.uid, value.monthId, value.yearId).then((dateRR) => {
    //       this.props.setHsNs(dateRR);
    //     });
    //   }
    // }
  };
  setInitialValues(props) {
    const { widget_permission } = getSingleModule_widget(
      props.user,
      accessText.purchase_order,
      accessText.hsn_codes
    );
    const tabs = this.state.tabs.map((e, i) => {
      const tab = e;
      // has_read_permission:true,has_create_permission:true
      tab.widget = widget_permission?.widget
        ? { ...widget_permission?.widget }
        : null;
      tab.data =
        props[EndPoints["HsNs"]] && props[EndPoints["HsNs"]].length > 0
          ? props[EndPoints["HsNs"]].sort((a, b) => {
              var dateA = moment(b.created_at).format("MMM D YYYY h:mm:ss A");
              var dateB = moment(a.created_at).format("MMM D YYYY h:mm:ss A");
              return new Date(dateA) - new Date(dateB);
            })
          : [];
      return tab;
    });

    this.setState({
      listViewArray:
        props[EndPoints["HsNs"]] && props[EndPoints["HsNs"]].length > 0
          ? props[EndPoints["HsNs"]]
          : [],
      HsNs: props.HsNs,
      tabs,
      loading: props.loading,
    });
  }
  render() {
    const { singlelistView, tabs, HsNs, listViewArray, loading } = this.state;
    // const { isMobile ,user} = this.props;
    const { user } = this.props;

    const { widget_permission } = getSingleModule_widget(
      user,
      accessText.purchase_order,
      accessText.hsn_codes
    );
    var labelField = "hsn_code";
    return (
      <Layout
        loading={loading[EndPoints["HsNs"]]}
        tabs={tabs}
        noTab={true}
        RaisedSearchBar={{
          data:
            listViewArray && listViewArray.length > 0
              ? listViewArray.map((sList) => {
                  sList.hsn_code = sList.hsn_code.toString();
                  return sList;
                })
              : [],
          hintText: "Search HSN",
          labelField: labelField,
        }}
        listClickHandler={this.listClickHandler}
        fabClickHandler={() => {
          this.setState({
            isPopup: true,
            isNew: true,
          });
        }}
        serchClick={this.searchHandler}
        centerWidth="230px"
        openWidth="465px"
        closeWidth="287px"
      >
        <Paper
          className="width-100 height-100 padding15 backgroundWhite"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          {singlelistView === null ? (
            <div className="d-flex width-100 height-100 justifyC alignC">
              <NoData />
            </div>
          ) : (
            // loading.HsNs === true ? (
            //   <div className="alignC justiyC d-flex width-100 height-100">
            //     <StyledCircularProgress color="inherit" />
            //   </div>
            // ) :
            <>
              <div style={{ width: "90%" }}>
                <h1 style={{ fontWeight: "400", fontSize: "25px" }}>
                  HSN Details
                </h1>
              </div>
              <Paper
                className="padding15 backgroundWhite"
                style={{
                  width: "90%",
                  display: "flex",
                  flexDirection: "column",
                }}
              > {widget_permission?.widget?.has_update_permission && (
                <div
                  style={{
                    width: "100%",
                    height: "50px",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Tooltip title="Edit">
                    <Icon
                      onClick={() => this.setState({ isPopup: true })}
                      style={{ cursor: "pointer" }}
                      component={ModeEdit}
                    />
                  </Tooltip>
                </div>
              )}
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    padding: "0 50px",
                    paddingBottom: "25px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "18px",
                        margin: "10px 0 ",
                        minWidth: "200px",
                      }}
                    >
                      HSN Code:
                    </p>
                    <p
                      style={{
                        fontSize: "18px",
                        margin: "10px 0 10px 10px",
                        color: "#808080",
                      }}
                    >
                      {singlelistView.hsn_code}
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "18px",
                        margin: "10px 0 ",
                        minWidth: "200px",
                      }}
                    >
                      Status:{" "}
                    </p>
                    <p
                      style={{
                        fontSize: "18px",
                        margin: "10px 0 10px 10px",
                        color: "#808080",
                      }}
                    >
                      {singlelistView.is_active ? "Active" : "Inactive"}
                    </p>
                  </div>
                </div>
              </Paper>
            </>
          )}
        </Paper>
        <Popup
          isNew={this.state.isNew}
          openPopup={this.state.isPopup}
          setOpenPopup={this.setStateOfPopup}
        >
          {this.state.isNew ? (
            <NewForm
              closePopup={this.setStateOfPopup}
              getFn={() => this.props.HsNsFunction("get", EndPoints["HsNs"])}
            />
          ) : (
            singlelistView !== null && (
              <EditForm
                isPopup={this.state.isPopup}
                getFn={(response) => {
                  if (response.data) {
                    this.setState({ singlelistView: response.data });
                  }
                  this.props.HsNsFunction("get", EndPoints["HsNs"]);
                  // if (response.data.is_active === false) {
                  //   this.setState({ singlelistView: null });
                  //   this.setStateOfPopup(false);
                  // }
                }}
                id={singlelistView.id}
                hsn={singlelistView.hsn_code}
                status={singlelistView.is_active}
                closePopup={this.setStateOfPopup}
              />
            )
          )}
        </Popup>
      </Layout>
    );
  }
}

export default HsNsComponent;
